import { z } from "zod";
export const activeSessionSchema = z.object({
    idusuario: z.number(),
    email: z.string(),
    fullName: z.string().nullable(),
    idcompany: z.number().nullable(),
    companyName: z.string().nullable(),
    loginAt: z.string(),
    ip: z.string().nullable(),
    userAgent: z.string().nullable(),
    durationMinutes: z.number(),
});
export const killSessionSchema = z.object({
    targetEmail: z.string().email(),
    targetGinaUsuarioId: z.number().int().positive().optional(),
    targetIdcompany: z.number().int().positive().optional(),
    reason: z.string().max(500).optional(),
});
export const sessionKillLogSchema = z.object({
    id: z.number(),
    at: z.string(),
    actorEmail: z.string().nullable(),
    targetEmail: z.string(),
    targetIdcompany: z.number().nullable(),
    reason: z.string().nullable(),
    success: z.boolean(),
});
//# sourceMappingURL=session.js.map